// extracted by mini-css-extract-plugin
module.exports = {"full":"style_full__2NXbq","hidden":"style_hidden__2Pe8h"};